export default function chainPropTypes(propType1, propType2) {
  if (process.env.NODE_ENV === 'production') {
    return () => null;
  }
  return function validate() {
    return propType1(...arguments) || propType2(...arguments);
  };
}